import {Injectable} from "@angular/core";

@Injectable()
export class JobMenuService {

  buttons = {
    hasEdit: (job, role) => job.canTurnOnEditMode() && role === 'organisation',
    hasUnpublish: (job, role) => job.canBeUnpublished() && role === 'organisation',
    hasRepublish: (job, role) => job.canBeRepublished() && role === 'organisation',
    hasRepublishAsNew: (job, role) => job.canBeRepublishedAsNew() && role === 'organisation',
    hasDelete: (job, role) => job.canBeDeleted() && role === 'organisation',
    hasCancel: (job, role) => job.status === 'accepted',
  };

  hasButtons(job, role){
    for(let methodName in this.buttons){
      if(job && role && this.buttons[methodName](job, role)){
        return true;
      }
    }

    return false;
  }

}



// WEBPACK FOOTER //
// ./src/pages/job/job-menu/job-menu.service.ts